class Text {
    static path = 'values/text';

    constructor(mutator){
        this.addOutput("value", "string");
        this.widgets_up = true;
        this.bgcolor = '#bfb5b2';
        this.title = 'Static Text';
        this.desc = 'Any short amount of text.';
        this.properties = {value: 'Text'};


        this.addWidget("text",this.properties.value,this.properties.value,(v) => {
            this.properties.value = v;
            if(v && this.isEmail(v)) {
                this.outputs[0].type = 'email,string';
            } else {
                this.outputs[0].type = 'string';
            }
        }, { property: "value"});
    }

    getTitle() {
        if (this.flags.collapsed) {
            return this.properties.value;
        }
        return this.title;
    }

    setValue(v) {
        this.setProperty("value",v);
        this.outputs[0].type = this.isEmail(v) ? 'email,string' : 'string';
    }

    onDrawBackground() {
        //show the current value
        this.outputs[0].label = this.properties["value"];
    }


    isEmail(email) {
        return /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/.test( email );
    }
}

module.exports = Text
